var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"v-actions-group",class:[
    _vm.data.class,
    _vm.data.staticClass,
    {
      'v-actions-group--right': _vm.props.alignRight,
    } ]},'div',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }